// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyAHOvUaCv3FSr1H_azITQlT5Lgy0QuJU1M",
//   authDomain: "mpower-u-76d19.firebaseapp.com",
//   projectId: "mpower-u-76d19",
//   storageBucket: "mpower-u-76d19.appspot.com",
//   messagingSenderId: "605795787295",
//   appId: "1:605795787295:web:fdd82e25a8be4990972b2a",
//   measurementId: "G-YWZ0FY93GX"
// };

const firebaseConfig = {
  apiKey: "AIzaSyCs7sj6RhDKCKZYBVmA7VctWVZWTQrPqjI",
  authDomain: "mpower-u-76d19.firebaseapp.com",
  projectId: "mpower-u-76d19",
  storageBucket: "mpower-u-76d19.appspot.com",
  messagingSenderId: "605795787295",
  appId: "1:605795787295:web:c5b14935c41f19c2972b2a",
  measurementId: "G-558H1CB32N"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
